import { useLocaleKeys } from '~/i18n';
import { useAgreementsChipConnector } from './agreementsChipConnector';
const BUNDLES_BI = {
    toggle: 'agreements_ai_chip_bundle_toggle_quantifier',
    remove: 'agreements_ai_chip_bundle_remove',
    prefix: 'agreements_ai_chip_bundle_name'
};
export const useAgreementsBundlesGrammar = ()=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    const connector = useAgreementsChipConnector();
    return {
        texts: t,
        connector,
        bi: BUNDLES_BI
    };
};
